/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddWhitelistRequest
 */
export interface AddWhitelistRequest {
    /**
     * 
     * @type {string}
     * @memberof AddWhitelistRequest
     */
    email: string;
}

/**
 * Check if a given object implements the AddWhitelistRequest interface.
 */
export function instanceOfAddWhitelistRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "email" in value;

    return isInstance;
}

export function AddWhitelistRequestFromJSON(json: any): AddWhitelistRequest {
    return AddWhitelistRequestFromJSONTyped(json, false);
}

export function AddWhitelistRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddWhitelistRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': json['email'],
    };
}

export function AddWhitelistRequestToJSON(value?: AddWhitelistRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
    };
}

